import { HeaderFixed } from '@/components';
import { EventDetails, TrackingEvents, TrackingStage } from '@/config/tracking';
import FlyersContext from '@/context/FlyersContext';
import { SearchBox } from '@/design-system';
import { useNavigateWithTracking } from '@/hooks';
import { KeyboardEvent, useContext, useState } from 'react';
import { css } from '@emotion/css';
import colors from '@/theme/colors';

export const JarSearchBox = () => {
  const [textSearch, setTextSearch] = useState<string>('');
  const navigateWithTracking = useNavigateWithTracking();

  const { activeTab } = useContext(FlyersContext);

  const trackingFrom = {
    event_from: TrackingEvents.browseContent,
    event_detail_from: EventDetails.browseContent(activeTab),
    stage_from: TrackingStage.discovery,
  };

  const onKeyDown = (e: KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && textSearch.length > 0) {
      const encodedSearch = encodeURIComponent(textSearch);
      navigateWithTracking(`/explore/${encodedSearch}/results?tab=${activeTab}`, trackingFrom);
    }
  };
  return (
    <div className={cn.searchBox}>
      <SearchBox
        value={textSearch}
        onChange={setTextSearch}
        onKeyDown={onKeyDown}
        placeholder="Search..."
      />
    </div>
  );
};

const cn = {
  searchBox: css`
    display: flex;
    align-items: center;
    flex-direction: row;
    width: 100%;
    padding: 24px 8px;
    color: ${colors.prussian};
  `,
};
